import Vue from 'vue'
import VueRouter from 'vue-router'
// import store from "../store";

Vue.use(VueRouter)

const routes = [{
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/molian',
    name: 'MOLIAN',
    component: () => import('../views/Home.vue'),
    children: [{
        path: '/list',
        name: 'List',
        component: () => import('../views/List.vue')
      },
      {
        path: '/adviser',
        name: 'Adviser',
        component: () => import('../views/Adviser.vue')
      },
      {
        path: '/localAdmin',
        name: 'LocalAdmin',
        component: () => import('../views/LocalAdmin.vue')
      },
      {
        path: '/',
        redirect: {
          name: 'List'
        }
      }
    ]
  },
  {
    path: '/',
    redirect: {
      name: 'Login'
    }
  },
]

const router = new VueRouter({
  routes
})


// VueRouter导航守卫 无登陆信息直接跳转到登陆页面
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const userInfo = JSON.parse(localStorage.getItem('userInfo'))
  if (token && to.path === "/adviser" && !userInfo.role.includes('admin')) {
    next({
      path: "/list"
    });
  }
  if (token && to.path === "/login") {
    next({
      path: "/list"
    });
  } else if (token || to.path === "/login") {
    next();
  } else {
    next({
      path: "/login"
    });
  }
});

export default router